<div class="modal-content">
  <div class="modal-header">
    <h4 class="modal-title" id="exampleModalLabel1">Editar Sake</h4>
    <button
      type="button"
      class="close"
      data-dismiss="modal"
      aria-label="Close"
      mat-dialog-close
    >
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <form [formGroup]="form" (ngSubmit)="onSubmit()">
      <div class="row">
        <div class="col-12 col-lg-6">
          <!-- TIPO DE SAKE -->
          <mat-form-field class="custom-select-form" style="width: 100%;">
            <mat-label>Tipo de Sake</mat-label>
            <mat-select formControlName="id_tipo_sake">
              <mat-option
                *ngFor="let tipo of tiposSakes"
                [value]="tipo.id_tipos_sakes"
              >
                {{ tipo.nombre }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>

        <div class="col-12 col-lg-6">
          <!-- NUMERO SAKE -->
          <mat-form-field style="width: 100%;">
            <mat-label>Número Sake</mat-label>
            <input
              type="text"
              formControlName="numero_sake"
              matInput
              placeholder="Ingrese su numero de sake"
            />
            <mat-error *ngIf="form.get('numero_sake').hasError('required')"
              >El Numero de Sake es <strong>requerido</strong></mat-error
            >
            <mat-error *ngIf="form.get('numero_sake').hasError('pattern')"
              >El Numero de Sake es <strong>invalido</strong></mat-error
            >
          </mat-form-field>
        </div>
      </div>

      <button
        [disabled]="form.status != 'VALID'"
        type="submit"
        class="btn btn-info waves-effect float-right"
      >
      <i class="far fa-save"></i>
        Guardar
      </button>
    </form>
  </div>
</div>
